// extracted by mini-css-extract-plugin
export default {"loginTitle":"LoginHead_loginTitle__kuZlf","loginLogo":"LoginHead_loginLogo__bLzog","loginLogoContainer":"LoginHead_loginLogoContainer__S2bOE"};